import React from "react";

function Footer() {
  return (
    <footer class = "footer" id = "contacts">
      <hr
        style={{
          color: "#0b032d",
          backgroundColor: "#0b032d",
          height: 2,
        }}
      />
      <div  class="container">
        <ul class="list-inline">
          <li class="list-inline-item"><a class="social-icon text-center text-white" target="_blank" href="https://www.fiit.stuba.sk/" rel="noreferrer">FIIT</a></li>
          <li class="list-inline-item"><a class="social-icon text-center text-white" target="_blank" href="https://gitlab.com/" rel="noreferrer">GitHub</a></li>
          <li class="list-inline-item"><a class="social-icon text-center text-white" target="_blank" href="https://qbsw.com/" rel="noreferrer">QBSW</a></li>
        </ul>
      </div>
      © 2021 Blockčejn Rendžerz | FIIT STU teamonefiit@gmail.com
    </footer>
  );
}

export default Footer;
